/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
const getCountry = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneMapping = {
    "Asia/Kabul": "Afghanistan",
    "Europe/Tirane": "Albania",
    "Africa/Algiers": "Algeria",
    "Europe/Andorra": "Andorra",
    "Africa/Luanda": "Angola",
    "America/Antigua": "Antigua and Barbuda",
    "America/Argentina/Buenos_Aires": "Argentina",
    "Asia/Yerevan": "Armenia",
    "Australia/Sydney": "Australia",
    "Europe/Vienna": "Austria",
    "Asia/Baku": "Azerbaijan",
    "America/Nassau": "Bahamas",
    "Asia/Bahrain": "Bahrain",
    "Asia/Dhaka": "Bangladesh",
    "America/Barbados": "Barbados",
    "Europe/Minsk": "Belarus",
    "Europe/Brussels": "Belgium",
    "America/Belize": "Belize",
    "Africa/Porto-Novo": "Benin",
    "Asia/Thimphu": "Bhutan",
    "America/La_Paz": "Bolivia",
    "Europe/Sarajevo": "Bosnia and Herzegovina",
    "Africa/Gaborone": "Botswana",
    "America/Sao_Paulo": "Brazil",
    "Asia/Brunei": "Brunei",
    "Europe/Sofia": "Bulgaria",
    "Africa/Ouagadougou": "Burkina Faso",
    "Africa/Bujumbura": "Burundi",
    "Asia/Phnom_Penh": "Cambodia",
    "Africa/Douala": "Cameroon",
    "America/Toronto": "Canada",
    "Atlantic/Cape_Verde": "Cape Verde",
    "Africa/Bangui": "Central African Republic",
    "Africa/Ndjamena": "Chad",
    "America/Santiago": "Chile",
    "Asia/Shanghai": "China",
    "America/Bogota": "Colombia",
    "Indian/Comoro": "Comoros",
    "Africa/Brazzaville": "Congo (Brazzaville)",
    "Africa/Kinshasa": "Congo (Kinshasa)",
    "America/Costa_Rica": "Costa Rica",
    "Europe/Zagreb": "Croatia",
    "America/Havana": "Cuba",
    "Asia/Nicosia": "Cyprus",
    "Europe/Prague": "Czech Republic",
    "Europe/Copenhagen": "Denmark",
    "Africa/Djibouti": "Djibouti",
    "America/Dominica": "Dominica",
    "America/Santo_Domingo": "Dominican Republic",
    "Asia/Dili": "East Timor",
    "America/Guayaquil": "Ecuador",
    "Africa/Cairo": "Egypt",
    "America/El_Salvador": "El Salvador",
    "Africa/Malabo": "Equatorial Guinea",
    "Africa/Asmara": "Eritrea",
    "Europe/Tallinn": "Estonia",
    "Africa/Mbabane": "Eswatini",
    "Africa/Addis_Ababa": "Ethiopia",
    "Pacific/Fiji": "Fiji",
    "Europe/Helsinki": "Finland",
    "Europe/Paris": "France",
    "Africa/Libreville": "Gabon",
    "Africa/Banjul": "Gambia",
    "Asia/Tbilisi": "Georgia",
    "Europe/Berlin": "Germany",
    "Africa/Accra": "Ghana",
    "Europe/Athens": "Greece",
    "America/Grenada": "Grenada",
    "America/Guatemala": "Guatemala",
    "Africa/Conakry": "Guinea",
    "Africa/Bissau": "Guinea-Bissau",
    "America/Guyana": "Guyana",
    "America/Port-au-Prince": "Haiti",
    "America/Tegucigalpa": "Honduras",
    "Europe/Budapest": "Hungary",
    "Atlantic/Reykjavik": "Iceland",
    "Asia/Kolkata": "India",
    "Asia/Jakarta": "Indonesia",
    "Asia/Tehran": "Iran",
    "Asia/Baghdad": "Iraq",
    "Europe/Dublin": "Ireland",
    "Asia/Jerusalem": "Israel",
    "Europe/Rome": "Italy",
    "America/Jamaica": "Jamaica",
    "Asia/Tokyo": "Japan",
    "Asia/Amman": "Jordan",
    "Asia/Almaty": "Kazakhstan",
    "Africa/Nairobi": "Kenya",
    "Pacific/Tarawa": "Kiribati",
    "Asia/Pyongyang": "Korea, North",
    "Asia/Seoul": "Korea, South",
    "Asia/Kuwait": "Kuwait",
    "Asia/Bishkek": "Kyrgyzstan",
    "Asia/Vientiane": "Laos",
    "Europe/Riga": "Latvia",
    "Asia/Beirut": "Lebanon",
    "Africa/Maseru": "Lesotho",
    "Africa/Monrovia": "Liberia",
    "Africa/Tripoli": "Libya",
    "Europe/Vaduz": "Liechtenstein",
    "Europe/Vilnius": "Lithuania",
    "Europe/Luxembourg": "Luxembourg",
    "Europe/Skopje": "Macedonia",
    "Indian/Antananarivo": "Madagascar",
    "Africa/Blantyre": "Malawi",
    "Asia/Kuala_Lumpur": "Malaysia",
    "Indian/Maldives": "Maldives",
    "Africa/Bamako": "Mali",
    "Europe/Malta": "Malta",
    "Pacific/Majuro": "Marshall Islands",
    "Africa/Nouakchott": "Mauritania",
    "Indian/Mauritius": "Mauritius",
    "America/Mexico_City": "Mexico",
    "Pacific/Chuuk": "Micronesia",
    "Europe/Chisinau": "Moldova",
    "Europe/Monaco": "Monaco",
    "Asia/Ulaanbaatar": "Mongolia",
    "Europe/Podgorica": "Montenegro",
    "Africa/Casablanca": "Morocco",
    "Africa/Maputo": "Mozambique",
    "Asia/Yangon": "Myanmar",
    "Africa/Windhoek": "Namibia",
    "Pacific/Nauru": "Nauru",
    "Asia/Kathmandu": "Nepal",
    "Europe/Amsterdam": "Netherlands",
    "Pacific/Auckland": "New Zealand",
    "America/Managua": "Nicaragua",
    "Africa/Niamey": "Niger",
    "Africa/Lagos": "Nigeria",
    "Europe/Oslo": "Norway",
    "Asia/Muscat": "Oman",
    "Asia/Karachi": "Pakistan",
    "Pacific/Palau": "Palau",
    "America/Panama": "Panama",
    "Pacific/Port_Moresby": "Papua New Guinea",
    "America/Asuncion": "Paraguay",
    "America/Lima": "Peru",
    "Asia/Manila": "Philippines",
    "Europe/Warsaw": "Poland",
    "Europe/Lisbon": "Portugal",
    "Asia/Qatar": "Qatar",
    "Europe/Bucharest": "Romania",
    "Europe/Moscow": "Russia",
    "Africa/Kigali": "Rwanda",
    "America/St_Kitts": "Saint Kitts and Nevis",
    "America/St_Lucia": "Saint Lucia",
    "America/St_Vincent": "Saint Vincent and the Grenadines",
    "Pacific/Apia": "Samoa",
    "Europe/San_Marino": "San Marino",
    "Africa/Sao_Tome": "Sao Tome and Principe",
    "Asia/Riyadh": "Saudi Arabia",
    "Africa/Dakar": "Senegal",
    "Europe/Belgrade": "Serbia",
    "Indian/Mahe": "Seychelles",
    "Africa/Freetown": "Sierra Leone",
    "Asia/Singapore": "Singapore",
    "Europe/Bratislava": "Slovakia",
    "Europe/Ljubljana": "Slovenia",
    "Pacific/Guadalcanal": "Solomon Islands",
    "Africa/Mogadishu": "Somalia",
    "Africa/Johannesburg": "South Africa",
    "Africa/Juba": "South Sudan",
    "Europe/Madrid": "Spain",
    "Asia/Colombo": "Sri Lanka",
    "Africa/Khartoum": "Sudan",
    "America/Paramaribo": "Suriname",
    "Europe/Stockholm": "Sweden",
    "Europe/Zurich": "Switzerland",
    "Asia/Damascus": "Syria",
    "Asia/Taipei": "Taiwan",
    "Asia/Dushanbe": "Tajikistan",
    "Africa/Dar_es_Salaam": "Tanzania",
    "Asia/Bangkok": "Thailand",
    "Africa/Lome": "Togo",
    "Pacific/Tongatapu": "Tonga",
    "America/Port_of_Spain": "Trinidad and Tobago",
    "Africa/Tunis": "Tunisia",
    "Europe/Istanbul": "Turkey",
    "Asia/Ashgabat": "Turkmenistan",
    "Pacific/Funafuti": "Tuvalu",
    "Africa/Kampala": "Uganda",
    "Europe/Kiev": "Ukraine",
    "Asia/Dubai": "United Arab Emirates",
    "Europe/London": "United Kingdom",
    "America/New_York": "United States",
    "America/Montevideo": "Uruguay",
    "Asia/Tashkent": "Uzbekistan",
    "Pacific/Efate": "Vanuatu",
    "Europe/Vatican": "Vatican City",
    "America/Caracas": "Venezuela",
    "Asia/Ho_Chi_Minh": "Vietnam",
    "Asia/Aden": "Yemen",
    "Africa/Lusaka": "Zambia",
    "Africa/Harare": "Zimbabwe"
  };
  return timeZoneMapping[timezone];
};
const selectCurrentCountry = () => {
  const select = document.querySelector('#country');
  const options = select.querySelectorAll('option');
  const currentCountry = getCountry();
  let activeIndex = 14;
  options.forEach((option, index) => {
    if (option.innerText.trim() === currentCountry) {
      activeIndex = index;
      return;
    }
  });
  select.value = options[activeIndex].value;
};
selectCurrentCountry();
/******/ })()
;